const joinRates = (rates) => (rates || []).join(', ');

// The GST hotel id as a number, so the column sorts numerically even if the int64 arrives as a
// string. A value that isn't a number is kept as received; a missing one becomes null.
const toHotelId = (value) => {
    if (value === undefined || value === null || value === '') {
        return null;
    }
    const number = Number(value);

    return Number.isFinite(number) ? number : value;
};

/**
 * Maps an included or excluded hotel of GET /api/campaigns/{id} to a hotel grid row.
 *
 * The rates are joined into the text the cell shows, so sorting a rate column orders the rows
 * by that text (GAP-1447). Excluded hotels have no rates, so theirs stay blank. A hotel whose
 * product row is gone comes back with its id only, and its other cells stay blank.
 */
export default function normalizeCampaignHotel(data) {
    return {
        hotelId: toHotelId(data.hotelId),
        partnerHotelId: String(data.partnerHotelId ?? ''),
        provider: data.provider || '',
        hotelName: data.name || '',
        sellableRates: joinRates(data.sellableRates),
        vipRates: joinRates(data.vipRates),
    };
}
